import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserProvider } from '../../providers/user/user';
@Injectable()
export class BibliaProvider {
  //TODO PEGAR KEY DO SISTEMA
  VERSAO: string = 'afc24de218ef6e38-01';
  API_BIBLIA: string = 'https://api.scripture.api.bible/v1/bibles/';
  API_KEY: string = '93ad60c6468f3d7bb682a5346d13dbd8';

  constructor(
    public http: HttpClient,
    public userProvider: UserProvider,
  ) {
    this.API_KEY = this.userProvider.hasBiblia();
  }

  getLivros() {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY,
    };
    console.log(header);
    return this.http.get<any>(this.API_BIBLIA + this.VERSAO + '/books', { headers: header }).map((data) => {
      if (!data.error) {
        return data.data;
      } else {
        return false;
      }
    });
  }

  getCapitulos(livro) {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY,
    };

    return this.http
      .get<any>(this.API_BIBLIA + this.VERSAO + '/books/' + livro + '/chapters', { headers: header })
      .map((data) => {
        if (!data.error) {
          //REMOVER INTRO
          let capitulos = [];
          data.data.forEach((element) => {
            if (element.number != 'intro') {
              capitulos.push(element);
            }
          });
          return capitulos;
        } else {
          return false;
        }
      });
  }

  getCapitulo(capitulo) {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY,
    };

    return this.http
      .get<any>(this.API_BIBLIA + this.VERSAO + '/passages/' + capitulo, {
        headers: header,
      })
      .map((data) => {
        if (!data.error) {
          return data.data;
        } else {
          return false;
        }
      });
  }

  getVersiculos(capitulo) {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY,
    };

    return this.http
      .get<any>(this.API_BIBLIA + this.VERSAO + '/chapters/' + capitulo + '/verses', { headers: header })
      .map((data) => {
        if (!data.error) {
          return data.data;
        } else {
          return false;
        }
      });
  }

  getVersiculo(versiculo) {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY,
    };

    return this.http
      .get<any>(this.API_BIBLIA + this.VERSAO + '/verses/' + versiculo, {
        headers: header,
      })
      .map((data) => {
        if (!data.error) {
          return data.data;
        } else {
          return false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/biblia/biblia.ts